import { render, staticRenderFns } from "./consudoc.vue?vue&type=template&id=eda06c52&scoped=true"
import script from "./consudoc.vue?vue&type=script&lang=js"
export * from "./consudoc.vue?vue&type=script&lang=js"
import style0 from "./consudoc.vue?vue&type=style&index=0&id=eda06c52&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda06c52",
  null
  
)

export default component.exports